module.exports = __webpack_public_path__ + "static/img/eoeos.994d1b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/eoeos.png
// module id = wSiT
// module chunks = 0